import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import {
  ModalContainer,
  ModalTitle,
  ModalSubtitle,
  Label,
  TextArea,
  ButtonArea,
  ErrorText,
} from "./JustificationFinalizationModal.styled";
import { GenericSolidButton, RedCancelButton } from "../UI/buttons/Button.styled";
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";

interface IJustificationFinalizationModal {
  visible: boolean;
  onConfirm: (justification: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const JustificationFinalizationModal: React.FC<IJustificationFinalizationModal> = ({
  visible,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const [justification, setJustification] = useState("");
  const [error, setError] = useState(false);
  const { isMobile } = useResponsiveInfo();

  const handleConfirm = () => {
    if (justification.length < 10) {
      setError(true);
      return;
    }
    onConfirm(justification);
    setJustification("");
    setError(false);
  };

  const handleCancel = () => {
    setJustification("");
    setError(false);
    onCancel();
  };

  return (
    <Modal open={visible}>
      <ModalContainer isMobile={isMobile}>
        <ModalTitle>Este atendimento foi realizado por outro profissional.</ModalTitle>
        <ModalSubtitle>Informe uma justificativa para finalizar</ModalSubtitle>
        
        <Label>Justificativa*</Label>
        <TextArea
          placeholder="Digite a justificativa"
          value={justification}
          onChange={(e) => {
            setJustification(e.target.value);
            if (e.target.value.length >= 10) setError(false);
          }}
        />
        {error && (
          <ErrorText>A justificativa deve conter no mínimo 10 caracteres.</ErrorText>
        )}

        <ButtonArea>
          <RedCancelButton onClick={handleCancel} style={{ width: "120px" }} disabled={isLoading}>
            Cancelar
          </RedCancelButton>
          <GenericSolidButton
            onClick={handleConfirm}
            color={Colors.SPM600}
            style={{ width: "120px" }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Finalizar"}
          </GenericSolidButton>
        </ButtonArea>
      </ModalContainer>
    </Modal>
  );
};

export default JustificationFinalizationModal;
